export const stretchAdjustment = {
  data() {
    return {
      currentGraphData: null,
      showChatDialog: false,
      isResizingWidth: false,
      isResizingHeight: false,
      isResizingBoth: false,
      startX: 0,
      startY: 0,
      dialogWidth: 380,
      dialogHeight: 700,
      iconPosition: "right", // 默认在右侧
    };
  },
  methods: {
    updateGraphData(data) {
      console.log("父组件接收到图数据:", data);
      this.currentGraphData = data;
    },
    toggleChatDialog() {
      this.showChatDialog = !this.showChatDialog;
    },
    togglePosition() {
      this.iconPosition = this.iconPosition === "right" ? "left" : "right";
      // 保存用户偏好到本地存储
      localStorage.setItem("ai-chat-position", this.iconPosition);
    },
    startResizingWidth(e) {
      this.isResizingWidth = true;
      this.startX = e.clientX;
      document.addEventListener("mousemove", this.resizeWidth);
      document.addEventListener("mouseup", this.stopResizing);
    },
    startResizingHeight(e) {
      this.isResizingHeight = true;
      this.startY = e.clientY;
      document.addEventListener("mousemove", this.resizeHeight);
      document.addEventListener("mouseup", this.stopResizing);
    },
    startResizingBoth(e) {
      this.isResizingBoth = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      document.addEventListener("mousemove", this.resizeBoth);
      document.addEventListener("mouseup", this.stopResizing);
    },
    resizeWidth(e) {
      if (this.isResizingWidth || this.isResizingBoth) {
        const deltaX = e.clientX - this.startX;
        // 根据对话框位置调整宽度变化方向
        const widthDelta = this.iconPosition === "right" ? -deltaX : deltaX;

        this.dialogWidth = Math.max(
          350,
          Math.min(1200, this.dialogWidth + widthDelta)
        );
        this.startX = e.clientX;
        if (this.$refs.chatDialog) {
          this.$refs.chatDialog.style.width = `${this.dialogWidth}px`;
        }
      }
    },
    resizeHeight(e) {
      if (this.isResizingHeight || this.isResizingBoth) {
        const deltaY = e.clientY - this.startY;

        // 向上拖动时，deltaY为负，需要增加高度
        // 向下拖动时，deltaY为正，需要减少高度
        this.dialogHeight = Math.max(
          400,
          Math.min(980, this.dialogHeight - deltaY)
        );

        this.startY = e.clientY;
        if (this.$refs.chatDialog) {
          this.$refs.chatDialog.style.height = `${this.dialogHeight}px`;
          // 确保内容区域也适应新高度
          // console.log("调整高度为:", this.dialogHeight);
        }
      }
    },
    resizeBoth(e) {
      if (this.isResizingBoth) {
        this.resizeWidth(e);
        this.resizeHeight(e);
      }
    },
    stopResizing() {
      this.isResizingWidth = false;
      this.isResizingHeight = false;
      this.isResizingBoth = false;
      document.removeEventListener("mousemove", this.resizeWidth);
      document.removeEventListener("mousemove", this.resizeHeight);
      document.removeEventListener("mousemove", this.resizeBoth);
      document.removeEventListener("mouseup", this.stopResizing);

      // 保存用户偏好的尺寸到本地存储
      localStorage.setItem("ai-chat-width", this.dialogWidth);
      localStorage.setItem("ai-chat-height", this.dialogHeight);
    },
  },
  mounted() {
    // 从本地存储加载用户偏好的位置
    const savedPosition = localStorage.getItem("ai-chat-position");
    if (savedPosition) {
      this.iconPosition = savedPosition;
    }

    // 从本地存储加载用户偏好的尺寸
    const savedWidth = localStorage.getItem("ai-chat-width");
    const savedHeight = localStorage.getItem("ai-chat-height");
    if (savedWidth) {
      this.dialogWidth = parseInt(savedWidth);
    }
    if (savedHeight) {
      this.dialogHeight = parseInt(savedHeight);
    }

    // 应用初始尺寸
    this.$nextTick(() => {
      if (this.$refs.chatDialog) {
        this.$refs.chatDialog.style.width = `${this.dialogWidth}px`;
        this.$refs.chatDialog.style.height = `${this.dialogHeight}px`;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.resizeWidth);
    document.removeEventListener("mousemove", this.resizeHeight);
    document.removeEventListener("mousemove", this.resizeBoth);
    document.removeEventListener("mouseup", this.stopResizing);
  },
};
